export function schema_chercher_et_remplacer(prevColumnNames) {
	return {
		title: "Paramètres",
		type: "object",
		properties: {
			find: {
				title: "Recherches",
				type: "array",
				items: {
					type: "object",
					title: "Recherche",
					format: "categories",
					basicCategoryTitle: "Colonnes",
					properties: {
						colonne: {
							title: "Colonnes",
							anyOf: [
								{
									type: "array",
									title: "colonnes",
									default: [""],
									format: "table",
									items: {
										title: "Colonne",
										type: "string",
										options: {
											inputAttributes: {
												class: "form-control dropdown-colonne",
											},
										},
									},
								},
								{
									title: "Colonnes (regex)",
									default: ".*",
									type: "string",
								},
							],
						},
						find: {
							title: "Rechercher",
							type: "array",
							format: "table",
							items: {
								type: "object",
								title: "Rechercher",
								properties: {
									value: {
										type: "string",
										title: "Valeur",
									},
									column_value: {
										title: "Nom de colonne",
										type: "boolean",
										format: "checkbox",
									},
									regex: {
										type: "boolean",
										title: "Regex",
										format: "checkbox",
									},
									word: {
										title: "Mots isolés",
										type: "boolean",
										format: "checkbox",
									},
								},
							},
						},
						replace: {
							title: "Remplacer",
							type: "array",
							format: "table",
							items: {
								type: "object",
								title: "Remplacer",
								properties: {
									group: {
										type: "string",
										title: "Groupe",
									},
									replace: {
										title: "Remplacer par",
										type: "string",
									},
								},
							},
						},
						collect: {
							title: "Classer",
							type: "array",
							format: "table",
							items: {
								type: "object",
								title: "Classer",
								properties: {
									column: {
										type: "string",
										title: "Colonne",
									},
									group: {
										type: "string",
										title: "Groupe",
									},
									separator: {
										type: "string",
										title: "Separateur",
									},
								},
							},
						},
					},
				},
			},
		},
	};
}
